const WeddingCircleInPre = () => {
  return(
    <div className="fact-circle wedding-credit">
      <a href="/weddings/inclusions/?scrollTo=willreceive" className="circle-container circle-copy display-block">
        <small className="receive">receive</small><br/>
        <span className="rate">
          <big className="display-block">
            <small>$</small>1500</big>
            In Premium Perks
        </span>
        <div className="st-mini-div"/>
        <span className="your-own">
          {/* <span className="your-own">To Design Your Own</span> */}
          <span className="your-own">When You Stay</span>
          7+ Nights
        </span>
      </a>
    </div>
  );
};
export default WeddingCircleInPre;


